import { TransactionItemDrawerMode } from '@/features/transaction_items/List/type';
import { TooltipInput } from '@/features/transaction_items/components/Form/GeneralForm/TooltipInput/TooltipInput';
import { Placeholder } from '@/features/transaction_items/components/Form/Placeholder/Placeholder';
import { MinAndMaxLengthInputs } from '@/features/transaction_items/components/Form/TextAndAlphanumeric/MinAndMaxLengthInputs/MinAndMaxLengthInputs';
import { FC, memo } from 'react';

export type Props = {
  mode: TransactionItemDrawerMode;
};

export const TextAndAlphanumeric: FC<Props> = memo(({ mode }) => {
  return (
    <>
      <MinAndMaxLengthInputs mode={mode} />
      <TooltipInput mode={mode} />
      <Placeholder mode={mode} />
    </>
  );
});
TextAndAlphanumeric.displayName = 'TextAndAlphanumeric';
